import { HandleApiError } from "sr/helpers/functions/HandleApiError";
import { getEmployment } from "sr/utils/api/cleaner/getEmployment";

interface ParamsType {
cleanerId?:string
id?:string
setLoader?:(params:any)=> void
setData:(params:any)=> void
}

const fetchEmployment = async (param:ParamsType) => {
  try {
    param?.setLoader && param?.setLoader(true)
        const res = await getEmployment(param?.cleanerId, param?.id)
      if(res?.success===true) {
        param?.setData(res?.data)
        param?.setLoader && param?.setLoader(false)
      }
      }
  catch(e:any) {
    
    HandleApiError(e)
    param?.setLoader && param?.setLoader(false)
  }
};
export default fetchEmployment;